// extracted by mini-css-extract-plugin
module.exports = {"productImage":"KVu8O","productBadge":"zhpbP","badge":"_2Lvbn","defaultImage":"z_00G"};